import { z } from 'zod';

export enum LinearPriority {
  NoPriority = 0,
  Urgent = 1,
  High = 2,
  Medium = 3,
  Low = 4,
}

export enum LinearStatus {
  Backlog = '3f384a78-0609-4fcc-a6cf-a1e040cf7f8c',
  Todo = '56d849da-63bb-4c89-9361-f664e8e3b1d2',
  InProgress = '4367d984-85aa-497e-a84e-376672d4437a',
  InReview = '125eef8d-32c3-47a7-9cf5-8820ab0a7353',
  Done = '1ab7d0fe-e1c0-4a19-9564-ce291ee77acb',
  Canceled = '98fe14a8-4572-46e4-9088-c103875a8cee',
  Duplicate = '1fa45193-c578-4102-b0f8-64ea540afeb5',
}

export enum LinearAssignee {
  Andrew = '5ea1466e-d27e-4fd7-bdf2-a79d4ae7db72',
  Chesilyn = '52637e58-1460-404a-8b34-6b85c164fa9d',
  Ethan = 'e6bf73d7-e3f3-49e3-9465-5e543f29e0e9',
  Igor = '57222b7c-e98f-4f07-8624-ccf3bcaf042e',
  Jack = '68304629-baa7-4ae1-9ce7-272071677151',
  JP = '3f5caba2-c41a-40a1-a657-150dfb05c4bb',
  Julius = '77b1a220-970d-41c0-ae02-82da3e083891',
  Ryan = '51ef9ab7-cb72-4443-bb2b-bc9ac5164c6a',
}

export const linearIssueSchema = z.object({
  assigneeId: z.string().optional(),
  description: z.string().optional(),
  dueDate: z.date().optional(), // timeless date
  estimate: z.number().int().optional(), // int 0-5
  chatId: z.string(), // our chat id
  labelIds: z.array(z.string()).optional(), // issue labels
  priority: z.nativeEnum(LinearPriority).optional(), // issue priority
  projectId: z.string().optional(), // project
  stateId: z.string().optional(), // team state
  subscriberIds: z.array(z.string()).optional(), // subscribers
  title: z.string(),
});

export type LinearIssue = z.infer<typeof linearIssueSchema>;
